import React, { Suspense, useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';

import { history } from '../_config';
import { withToast } from '../contexts/toastr.context';
import { Loader } from './loader.component';
import UserMeetingPage, {
    USER_MEETING_ROUTE,
} from '../_pages/user.meeting.page';
import PublicRoute from './public-route.component';

import NotFoundPage from '../_pages/not-found.page';

function AuthAppComponent() {
    return (
        <div className="AuthApp">
            <Router history={history}>
                <Switch>
                    <>
                        <PublicRoute
                            component={UserMeetingPage}
                            path={USER_MEETING_ROUTE}
                        />
                        <PublicRoute path="*" component={NotFoundPage} />
                    </>
                </Switch>
            </Router>
        </div>
    );
}

const AuthApp = withToast(AuthAppComponent);

export default AuthApp;
